import "../assets/css/mobileNavigation.css"; // Add CSS for styling
import React, { useState } from "react";

import search from "../assets/images/mobilefooter/search1.svg";
import home from "../assets/images/mobilefooter/home.svg";
import puja from "../assets/images/mobilefooter/pooja.svg";
import logo from "../assets/images/logo/logoDark.png";
import profile from "../assets/images/mobilefooter/profile.png";
import { Link } from "react-router-dom";

const NavBar = () => {
  const navItems = [
    { label: "Stay", icon: home, path: "/accomodation" },
    { label: "Guide", icon: search, path: "/guide" },
    { label: "Home", icon: logo, path: "/" },
    { label: "E-puja", icon: puja, path: "/e-puja" },
    { label: "Events", icon: profile, path: "/tours-events" },
  ];
  const [activeTab, setActiveTab] = useState("Home" );


  const activeIndex = navItems.findIndex((item) => item.label === activeTab);

  const transformation = (value) => {
    if (value === 0) {
      return "2vw";
    } else if (value === 1) {
      return "21vw";
    } else if (value === 2) {
      return "50vw - 35px";
    } else if (value === 3) {
      return "60vw";
    } else if (value === 4) {
      return "78vw";
    }
  };


  

  return (
    <div className="nav-container shadow">
      <div
        className={activeTab === "Home" ? "homeIcon shadow" : "active-tab-bg shadow"}
        style={{
          transform: `translateX(calc(${transformation(activeIndex)}))`,
        }}
      ></div>

      <Link to={"/accomodation"}>
        <div
          className={`nav-item ${activeTab === "Stay" ? "active" : "" }`}
          onClick={() => setActiveTab("Stay")}
        >
          <img src={home} alt=""  style={{ width: "25px", height: "25px" , fill:"white"}} />
          { <span className="fs-8 text-dark" style={{ fontWeight: "500" }}>Stay</span>}
        </div>
      </Link>
      <Link to={"/guide"}>
        <div
          className={`nav-item ${activeTab === "Guide" ? "active" : ""}`}
          onClick={() => setActiveTab("Guide")}
        >
          <img src={search} alt="" style={{ width: "25px", height: "25px" }} />
           <span className="fs-8 text-dark" style={{ fontWeight: "500" }}>Guide</span>
        </div>
      </Link>
      <Link to={"/"}>
          <div
            className={`nav-item ${activeTab === "Home" ? "active" : ""} d-flex flex-column justify-content-center ` }
            onClick={() => setActiveTab("Home")}
          >
            
            <img src={logo} alt="" style={{ width: "40px", height: "40px", position:"absolute" }} />            
          </div>
       
      </Link>
      <Link to={"/e-puja"}>
        <div
          className={`nav-item ${activeTab === "E-puja" ? "active" : ""}`}
          onClick={() => setActiveTab("E-puja")}
        >
          <img src={puja} alt="" style={{ width: "25px", height: "25px" }} />
           <span className="fs-8 text-dark" style={{ fontWeight: "500" }}>E-puja</span>
        </div>
      </Link>
      <Link to={'/tours-events'} onClick={() =>  setActiveTab( "Events")}>
        <div
          className={`nav-item ${activeTab === "Events" ? "active" : ""}`}
        >
          <img src={profile} alt="" style={{ width: "25px", height: "25px" }} />
          <span className="fs-8 text-dark" style={{ fontWeight: "500" }}>Events</span>
        </div>
      </Link>

    </div>
  );
};

export default NavBar;
